import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RatingComponentDef } from '@df/ui/common/rating.component.def';
@Component({
    selector: 'rating',
    templateUrl: './rating.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class RatingComponent extends RatingComponentDef {}
